import type { LoaderFunctionArgs } from "react-router";
import { promiseAuthorization } from "src/configs/authorization/promise";
import { PAGES, PAGE_URLS } from "src/configs/pages-urls";
import { authorizationLoader } from "src/router/common-loaders";
import { convertFrameworkRoute } from "src/utils/routes";

export default [
	{
		index: true,
		loader: async ({
			params: { accountId: accountIdParam },
		}: LoaderFunctionArgs) =>
			authorizationLoader(
				{
					accountIdParam,
					conditionalRedirect: true,
				},
				promiseAuthorization.promises.index,
				[
					{
						redirectUrl: PAGE_URLS.promise().carrierLevel,
						abilityArguments:
							promiseAuthorization.promises.carrierLevel,
					},
					{
						redirectUrl: PAGE_URLS.promise().warehouses,
						abilityArguments:
							promiseAuthorization.promises.warehouses,
					},
					{
						redirectUrl: PAGE_URLS.promise().deliveryMethods,
						abilityArguments:
							promiseAuthorization.promises.deliveryMethods,
					},
					{
						redirectUrl:
							PAGE_URLS.promise().deliveryPredictionService,
						abilityArguments:
							promiseAuthorization.promises
								.deliveryPredictionService,
					},
					{
						redirectUrl: PAGE_URLS.promise().promiseAnalytics,
						abilityArguments:
							promiseAuthorization.promises.analytics,
					},
				],
			),
	},
	{
		path: PAGES.promise.sub.promiseLanding,
		lazy: () =>
			import("src/module--promise/pages/PromiseLanding.page").then(
				convertFrameworkRoute,
			),
	},
	{
		path: PAGES.promise.sub.carrierLevel,
		lazy: () =>
			import(
				"src/module--promise/pages/PromiseCarrierLevelList.page"
			).then(convertFrameworkRoute),
		children: [
			{
				path: "new",
				lazy: () =>
					import(
						"src/module--promise/pages/PromiseCarrierLevelNew.page"
					).then(convertFrameworkRoute),
			},
			{
				path: ":promiseId",
				lazy: () =>
					import(
						"src/module--promise/pages/PromiseCarrierLevelEdit.page"
					).then(convertFrameworkRoute),
			},
		],
	},
	{
		path: PAGES.promise.sub.warehouses,
		lazy: () =>
			import("src/module--promise/pages/PromiseWarehousesList.page").then(
				convertFrameworkRoute,
			),
		children: [
			{
				path: "new",
				lazy: () =>
					import(
						"src/module--promise/pages/PromiseWarehousesNew.page"
					).then(convertFrameworkRoute),
			},
			{
				path: ":promiseId",
				lazy: () =>
					import(
						"src/module--promise/pages/PromiseWarehousesEdit.page"
					).then(convertFrameworkRoute),
			},
		],
	},
	{
		path: PAGES.promise.sub.deliveryMethods,
		lazy: () =>
			import(
				"src/module--promise/pages/PromiseDeliveryMethodsList.page"
			).then(convertFrameworkRoute),
		children: [
			{
				path: "new",
				lazy: () =>
					import(
						"src/module--promise/pages/PromiseDeliveryMethodsNew.page"
					).then(convertFrameworkRoute),
			},
			{
				path: ":promiseId",
				lazy: () =>
					import(
						"src/module--promise/pages/PromiseDeliveryMethodsEdit.page"
					).then(convertFrameworkRoute),
			},
		],
	},
	{
		path: PAGES.promise.sub.deliveryPredictionService,
		lazy: () =>
			import(
				"src/module--promise/pages/PromiseServicePrediction.page"
			).then(convertFrameworkRoute),
	},
	{
		path: PAGES.promise.sub.promiseAnalytics,
		lazy: () =>
			import("src/module--promise/pages/PromiseReport.page").then(
				convertFrameworkRoute,
			),
	},
];
